/* eslint-disable */
import axios from "axios";

// ============================================================
// ENVIRONMENT CONFIGURATION
// ============================================================
// UAT:  npm run build:uat   → homabay_uat + rcmsuat …/homabay_hrmis/
// Prod: npm run build       → homabay + api.craftcollect.africa/hrmis/
// Options: 'localhost', 'demo', 'uat', 'homabay', 'homabay_uat', 'production'
function resolveActiveEnv() {
  const fromBuild = process.env.VUE_APP_ACTIVE_ENV || "";
  if (typeof window !== "undefined" && window.location?.hostname) {
    const host = window.location.hostname.toLowerCase();
    // SPA on UAT host must call homabay_hrmis, even if a prod build was deployed by mistake.
    if (host === "rcmsuat.craftsilicon.com" || host.endsWith(".rcmsuat.craftsilicon.com")) {
      return "homabay_uat";
    }
  }
  return fromBuild || "localhost";
}
const ACTIVE_ENV = resolveActiveEnv();

const ENV_URLS = {
  localhost: process.env.VUE_APP_BASE_URL_HRMS_LOCALHOST || "http://localhost/homabay-hr/authentication",
  demo: process.env.VUE_APP_BASE_URL_HRMS_DEMO || "https://api.paysol.co.ke/hrms/authentication/",
  uat: process.env.VUE_APP_BASE_URL_HRMS_UAT || "https://staffsync.cspl-uat.site/authentication/",
  production: process.env.VUE_APP_BASE_URL_HRMS || "https://rcmsuat.craftsilicon.com/hrmis-api/authentication/",
  homabay: process.env.VUE_APP_BASE_URL_HRMS_HOMABAY || "https://api.craftcollect.africa/hrmis/",
  homabay_uat: process.env.VUE_APP_BASE_URL_HRMS_HOMABAY_UAT || "https://rcmsuat.craftsilicon.com/homabay_hrmis/"
};

// Get the selected environment URL
const getBaseUrl = () => {
  const selectedUrl = ENV_URLS[ACTIVE_ENV] || ENV_URLS.localhost;
  return selectedUrl.replace(/\/+$/, ""); // Remove trailing slashes
};

const hrmsBase = getBaseUrl();

let localDevBase = hrmsBase;
try {
  localDevBase = new URL(hrmsBase).pathname.replace(/\/+$/, "");
} catch (e) {
  // hrmsBase may not be a valid absolute URL in some edge cases
}

// Development: relative path so vue.config.js proxies to XAMPP (same-origin, no CORS issues on login).
export const base = process.env.NODE_ENV === "development" && ACTIVE_ENV === "localhost"
  ? localDevBase
  : hrmsBase;

console.log(`🌍 Active Environment: ${ACTIVE_ENV}`);
console.log(`🔗 Base URL: ${base}`);
//export const base = process.env.VUE_APP_BASE_URL_HRMS_HOMABAY_UAT
//export const base = process.env.VUE_APP_BASE_URL_HRMS_HOMABAY

export const county_logo = base + "/logos/logo.png";
export const login_bg = base + "/logos/bg-auth-overlay.png";
export const paysol = base + "/paysol/index.php";
export const authUrl = base + "/index.php";

export const uploads = base;



// Toast notification utility
export const toast = {
    success(message) {
        this._showToast(message, 'success');
    },
    error(message) {
        this._showToast(message, 'error');
    },
    warning(message) {
        this._showToast(message, 'warning');
    },
    info(message) {
        this._showToast(message, 'info');
    },
    _showToast(message, type) {
        // Create toast element
        const toast = document.createElement('div');
        toast.className = `toast-notification toast-${type}`;
        toast.style.cssText = `
      position: fixed;
      min-width: 250px;
      margin-bottom: 10px;
      padding: 15px;
      border-radius: 4px;
      box-shadow: 0 2px 10px rgba(0,0,0,0.2);
      transform: translateY(30px);
      opacity: 0;
      transition: all 0.3s ease;
      z-index: 9999;
      color: white;
    `;

        // Apply color based on type
        switch(type) {
            case 'success':
                toast.style.backgroundColor = '#4caf50';
                break;
            case 'error':
                toast.style.backgroundColor = '#f44336';
                break;
            case 'warning':
                toast.style.backgroundColor = '#ff9800';
                break;
            case 'info':
                toast.style.backgroundColor = '#2196f3';
                break;
        }

        toast.innerHTML = `
      <div style="display: flex; align-items: center;">
        <div style="flex-grow: 1;">${message}</div>
      </div>
    `;

        // Add to DOM
        const container = document.getElementById('toast-container') || this._createContainer();
        container.appendChild(toast);

        // Trigger animation
        setTimeout(() => {
            toast.style.transform = 'translateY(0)';
            toast.style.opacity = '1';
        }, 10);

        // Auto-remove after 3 seconds
        setTimeout(() => {
            toast.style.transform = 'translateY(30px)';
            toast.style.opacity = '0';
            setTimeout(() => {
                if (container.contains(toast)) {
                    container.removeChild(toast);
                }
                // Remove container if empty
                if (container.children.length === 0 && document.body.contains(container)) {
                    document.body.removeChild(container);
                }
            }, 300);
        }, 3000);
    },
    _createContainer() {
        const container = document.createElement('div');
        container.id = 'toast-container';
        container.style.cssText = `
      position: fixed;
      bottom: 20px;
      right: 20px;
      z-index: 9999;
    `;
        document.body.appendChild(container);
        return container;
    }
};

export const execute = (params, url) => {
    if (params instanceof FormData && !params.has("deviceDetails")) {
      params.append("deviceDetails", getClientDeviceDetails());
    }
    const tokenStr = sessionStorage.getItem("tokenSession");
    return axios.post(url,params,{headers: {"Authorization": `Bearer ${tokenStr}`}})
}

/**
 * Multipart upload helper: long timeout, optional retries, optional progress.
 * params may be FormData or a factory () => FormData (preferred for retries with files).
 * Mitigates flaky large-file POSTs (proxy drop / ERR_NETWORK_CHANGED).
 */
export const executeUpload = async (params, url, options = {}) => {
    const {
      timeout = 15 * 60 * 1000,
      retries = 2,
      onUploadProgress = null,
      retryDelayMs = 1500,
    } = options;
    const buildBody = typeof params === "function" ? params : () => params;
    const tokenStr = sessionStorage.getItem("tokenSession");
    let lastErr = null;
    for (let attempt = 0; attempt <= retries; attempt += 1) {
      try {
        const body = buildBody();
        if (body instanceof FormData && !body.has("deviceDetails")) {
          body.append("deviceDetails", getClientDeviceDetails());
        }
        return await axios.post(url, body, {
          headers: { Authorization: `Bearer ${tokenStr}` },
          timeout,
          maxContentLength: Infinity,
          maxBodyLength: Infinity,
          onUploadProgress: typeof onUploadProgress === "function" ? onUploadProgress : undefined,
        });
      } catch (e) {
        lastErr = e;
        const code = e?.code || e?.message || "";
        const retriable =
          code === "ERR_NETWORK" ||
          code === "ECONNABORTED" ||
          /Network Error|timeout|ERR_NETWORK/i.test(String(e?.message || code));
        if (!retriable || attempt >= retries) break;
        await new Promise((r) => setTimeout(r, retryDelayMs * (attempt + 1)));
      }
    }
    throw lastErr;
};

export const executeJson = (params, url) => {
    const tokenStr = sessionStorage.getItem("tokenSession");
    return axios.post(url, params, {
        headers: {
            "Authorization": `Bearer ${tokenStr}`,
            "Content-Type": "application/json"
        }
    });
}

export const executeDownload = (params, url) => {
    const tokenStr = sessionStorage.getItem("tokenSession");
    return axios.post(url,params,{headers: {"Authorization": `Bearer ${tokenStr}`}, responseType: 'blob'})
}

/** Collect client device/browser details for audit logging on every API request. */
export function getClientDeviceDetails() {
  if (typeof navigator === "undefined") return "";
  let os = "Unknown";
  const ua = navigator.userAgent || "";
  if (ua.indexOf("Win") !== -1) os = "Windows";
  else if (ua.indexOf("Mac") !== -1) os = "MacOS";
  else if (ua.indexOf("Linux") !== -1) os = "Linux";
  else if (ua.indexOf("Android") !== -1) os = "Android";
  else if (ua.indexOf("iOS") !== -1 || ua.indexOf("iPhone") !== -1 || ua.indexOf("iPad") !== -1) os = "iOS";

  let browser = "Unknown";
  if (ua.indexOf("Edg/") !== -1 || ua.indexOf("Edge") !== -1) browser = "Edge";
  else if (ua.indexOf("Chrome") !== -1) browser = "Chrome";
  else if (ua.indexOf("Firefox") !== -1) browser = "Firefox";
  else if (ua.indexOf("Safari") !== -1) browser = "Safari";
  else if (ua.indexOf("MSIE") !== -1 || !!document.documentMode) browser = "Internet Explorer";

  const screenResolution = typeof window !== "undefined"
    ? `${window.screen.width} x ${window.screen.height}`
    : "Unknown";
  const cpuCores = navigator.hardwareConcurrency || "Unknown";
  const memory = navigator.deviceMemory || "Unknown";
  return `os: ${os} | browser: ${browser} | screenResolution: ${screenResolution} | cpuCores: ${cpuCores} | memory: ${memory}`;
}

function appendDeviceDetailsToRequest(config) {
  const data = config?.data;
  if (!data || typeof FormData === "undefined" || !(data instanceof FormData)) return;
  if (data.has("deviceDetails")) return;
  data.append("deviceDetails", getClientDeviceDetails());
}

/** Unauthenticated API calls (login, forgot password, etc.) — must not trigger session logout. */
export const execute2 = (params, url) => {
    if (params instanceof FormData && !params.has("deviceDetails")) {
      params.append("deviceDetails", getClientDeviceDetails());
    }
    return axios.post(url, params, { skipSessionGuard: true });
}

// Session guard: auto-logout when user signs in elsewhere
const PUBLIC_AUTH_FUNCTIONS = new Set([
  "loginPortal",
  "loginApp",
  "forgotPassword",
  "generatePassword",
  "OTPVerification",
  "OTPVerificationApp",
]);

function requestFunctionName(config) {
  if (!config) return "";
  if (config.skipSessionGuard === true) return "__public__";
  const data = config.data;
  if (!data) return "";
  try {
    if (typeof FormData !== "undefined" && data instanceof FormData) {
      return String(data.get("function") || "").trim();
    }
    if (typeof URLSearchParams !== "undefined" && data instanceof URLSearchParams) {
      return String(data.get("function") || "").trim();
    }
    if (typeof data === "object" && data.function) {
      return String(data.function).trim();
    }
  } catch (_) {}
  return "";
}

function requestSkipsSessionGuard(config) {
  if (!config) return false;
  if (config.skipSessionGuard === true) return true;
  const fn = requestFunctionName(config);
  return fn === "__public__" || PUBLIC_AUTH_FUNCTIONS.has(fn);
}
const LOGOUT_REASON_KEY = "hb_logout_reason";
const LOGOUT_BROADCAST_KEY = "hb_logout_broadcast";

function sessionMessageFromPayload(data) {
  return data?.message || data?.Message || data?.error || "";
}

function isSessionLogoutMessage(msg) {
  const msgStr = String(msg || "").toLowerCase();
  return (
    msgStr.includes("session has expired") ||
    msgStr.includes("signed in on another device") ||
    msgStr.includes("signed out") ||
    msgStr.includes("unauthorized")
  );
}

export function forceLogout(reasonMessage = "Your session has expired.", options = {}) {
  const skipBroadcast = options?.skipBroadcast === true;
  const msg = String(reasonMessage || "Your session has expired.");
  if (!skipBroadcast) {
    try {
      localStorage.setItem(LOGOUT_BROADCAST_KEY, JSON.stringify({ msg, t: Date.now() }));
    } catch (_) {}
  }
  try {
    sessionStorage.setItem(LOGOUT_REASON_KEY, msg);
  } catch (_) {}
  try { sessionStorage.clear(); } catch (_) {}
  try {
    if (window.location.hash !== "#/") window.location.hash = "#/";
    else window.location.reload();
  } catch (_) {}
}

function isSessionExpiredResponse(err) {
  if (requestSkipsSessionGuard(err?.config)) return false;
  const status = err?.response?.status;
  const data = err?.response?.data;
  const msg = sessionMessageFromPayload(data);
  if (status === 401) return true;
  if (data?.success === false && isSessionLogoutMessage(msg)) return true;
  return isSessionLogoutMessage(msg);
}

function logoutMessageFromError(err, fallback = "Your session has expired.") {
  const msg = sessionMessageFromPayload(err?.response?.data);
  return String(msg || "").trim() || fallback;
}

function shouldForceLogoutFromSuccessResponse(resp) {
  if (requestSkipsSessionGuard(resp?.config)) return false;
  const data = resp?.data;
  if (!data || data.success !== false) return false;
  return isSessionLogoutMessage(sessionMessageFromPayload(data));
}

let _authInterceptorInstalled = false;
export function installAuthInterceptors() {
  if (_authInterceptorInstalled) return;
  _authInterceptorInstalled = true;

  axios.interceptors.request.use((config) => {
    appendDeviceDetailsToRequest(config);
    return config;
  });

  window.addEventListener("storage", (e) => {
    if (e.key !== LOGOUT_BROADCAST_KEY || !e.newValue) return;
    if (sessionStorage.getItem("isLoggedIn") !== "true") return;
    try {
      const payload = JSON.parse(e.newValue);
      forceLogout(payload?.msg || "You have been signed out because you signed in on another device.", {
        skipBroadcast: true,
      });
    } catch (_) {
      forceLogout("You have been signed out because you signed in on another device.", { skipBroadcast: true });
    }
  });

  axios.interceptors.response.use(
    (resp) => {
      if (shouldForceLogoutFromSuccessResponse(resp)) {
        const msg = sessionMessageFromPayload(resp.data);
        forceLogout(String(msg || "").trim() || "Your session has expired.");
        return Promise.reject(new Error(msg || "Session ended"));
      }
      return resp;
    },
    (err) => {
      if (isSessionExpiredResponse(err)) {
        forceLogout(logoutMessageFromError(err));
      }
      return Promise.reject(err);
    }
  );
}

let _heartbeatTimer = null;
export function startSessionHeartbeat(intervalMs = 10000) {
  if (_heartbeatTimer) return;
  const tick = async () => {
    try {
      const tokenStr = sessionStorage.getItem("tokenSession");
      const isLoggedIn = sessionStorage.getItem("isLoggedIn") === "true";
      if (!tokenStr || !isLoggedIn) return;

      const data = new FormData();
      data.append("function", "validateSession");
      const resp = await axios.post(authUrl, data, {
        headers: { Authorization: `Bearer ${tokenStr}` },
        validateStatus: () => true,
      });
      if (shouldForceLogoutFromSuccessResponse(resp) || resp.status === 401) {
        forceLogout(sessionMessageFromPayload(resp.data) || "Your session has expired.");
        return;
      }
    } catch (e) {
      if (isSessionExpiredResponse(e)) {
        forceLogout(logoutMessageFromError(e));
      }
    }
  };
  tick();
  _heartbeatTimer = setInterval(tick, Math.max(5000, Number(intervalMs) || 10000));
}

export function readAndClearLogoutReason() {
  try {
    const msg = sessionStorage.getItem(LOGOUT_REASON_KEY);
    if (msg) sessionStorage.removeItem(LOGOUT_REASON_KEY);
    return msg || "";
  } catch (_) {
    return "";
  }
}

/**
 * Check if current user has a permission (RBAC).
 * Uses rbac_permissions from getPermissionsAndMenus when available; else falls back to selectedRoles (legacy).
 * No category or role-name superuser bypass — ADMIN/SUPERADMIN must have permissions via roles like everyone else.
 * accessRole can be a string (single permission) or array of strings (user needs any one).
 */
export const getRight = (accessRole) => {
    if (!accessRole) return true;
    const codes = Array.isArray(accessRole) ? accessRole : [accessRole];
    // Match backend hasPermission: ignore spaces/underscores/hyphens
    const norm = (s) => String(s || '').trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
    let rbacLoaded = false;
    let rbacPerms = [];
    try {
        rbacLoaded = sessionStorage.getItem("rbac_menus_loaded") === "1";
        const rbacStr = sessionStorage.getItem("rbac_permissions");
        if (rbacStr) {
            const perms = JSON.parse(rbacStr);
            if (Array.isArray(perms)) rbacPerms = perms;
        }
    } catch (_) {}

    for (const access of codes) {
        const code = norm(access);
        if (!code) continue;

        if (rbacPerms.some((p) => norm(p) === code)) return true;

        // When RBAC has already loaded in this session, do NOT fallback to legacy selectedRoles.
        if (rbacLoaded) continue;

        const selectedRolesString = sessionStorage.getItem("selectedRoles");
        if (selectedRolesString) {
            try {
                const selectedRoles = JSON.parse(selectedRolesString);
                if (Array.isArray(selectedRoles)) {
                    for (const role of selectedRoles) {
                        const name = role.role_name || role.roleName || '';
                        if (norm(name) === code) return true;
                    }
                }
            } catch (e) {
                console.error("Error parsing selectedRoles:", e);
            }
        }
    }
    return false;
};

/** Fetch permissions and menus from backend (RBAC). Stores rbac_permissions and rbac_menus in sessionStorage. */
let rbacFetchInFlight = null;
export const fetchPermissionsAndMenus = (authUrl, execute) => {
    if (rbacFetchInFlight) return rbacFetchInFlight;
    const data = new FormData();
    data.append("function", "getPermissionsAndMenus");
    rbacFetchInFlight = execute(data, authUrl).then((res) => {
        if (res.data && res.data.success && res.data.data) {
            const d = res.data.data;
            sessionStorage.setItem("rbac_permissions", JSON.stringify(d.permissions || []));
            sessionStorage.setItem("rbac_menus", JSON.stringify(d.menus || []));
            sessionStorage.setItem("rbac_context", JSON.stringify(d.context || {}));
            sessionStorage.setItem("rbac_menus_loaded", "1");
        }
        return res;
    }).finally(() => {
        rbacFetchInFlight = null;
    });
    return rbacFetchInFlight;
};

/**
 * Format Kenyan mobile number to 254XXXXXXXXX.
 * Converts 0726642205, +254726642205, 254726642205 to 254726642205.
 * Handles numbers and scientific notation (e.g. 2.54705E+11) so they display as full digits.
 * @param {string|number} value - Raw phone (0726642205, +254726642205, 254726642205, or number)
 * @returns {string} - 254726642205 format, or original if not a Kenyan mobile
 */
export const formatMobileKe = (value) => {
    if (value == null || value === '') return value;
    // Avoid scientific notation: coerce number or "2.54705E+11" to full digit string
    let s;
    if (typeof value === 'number' || (typeof value === 'string' && /e[+-]?\d+/i.test(value))) {
        const n = Number(value);
        if (!Number.isNaN(n)) s = n >= 1e9 ? String(Math.floor(n)) : String(value).trim();
        else s = String(value).trim();
    } else {
        s = String(value).trim();
    }
    const digits = s.replace(/\D/g, '');
    if (digits.length < 9) return s;
    if (digits.startsWith('0') && digits.length >= 10) return '254' + digits.substring(1);
    if (digits.startsWith('254')) return digits.length > 12 ? digits.substring(0, 12) : digits;
    if (digits.length >= 9) return '254' + digits.slice(-9);
    return s;
};